"use strict";


(function() {
	const forms = Array.from(document.querySelectorAll('.public-form'));
	
	forms.forEach(form => {
		let submitting = false;
		
		form.addEventListener('submit', function(event) {
			if( submitting ) { 
				event.preventDefault();
				return;
			}
			
			submitting = true;
			form.querySelectorAll('[type=submit]').forEach(b => {
				b.setAttribute('disabled', true);
			});
		});
	});
})();



(function() {
	
	const initializedClass = '-initialized';
	const selectedClass = 'selected';
	
	const _arrayUnique = (value, index, array) => array.indexOf(value) === index;
	
	const _appName = element => element.querySelector('.app--title').textContent;
	
	const Selectboxes = root => {
		root.classList.add(initializedClass);
		const elements = Array.from(root.querySelectorAll('.selectbox'));

		const __checkbox = element => element.querySelector('input[type=checkbox]');
		
		const _select = element => {
			const checkbox = __checkbox(element);
			
			element.classList.add(selectedClass);
			if( checkbox && ! checkbox.checked ) {
				checkbox.checked = true;
			}
			
			if( element.dataset.dependencies ) {
				element.dataset.dependencies.split(',').forEach(id => {
					const dependency = root.querySelector(`#_${id}`);
					dependency && _select(dependency);
				});
			}
		};
		
		
		const _deselect = element => {
			
			/*
			 * Check if clicked app is not a 
			 * required dependency 
			 */
			const requiredBySelection = elements.map(_e => {
				if( _e.getAttribute('id') === element.getAttribute('id') ) {
					return null;
				}
				
				if( _e.classList.contains(selectedClass) ) {
					if( _e.dataset.dependencies ) {
						const dp = _e.dataset.dependencies.split(',');
						const id = element.getAttribute('id').slice(1);
						if( dp.indexOf(id) > -1 ) {
							return _appName(_e);
						}
					}
				}
				
				return null;
			}).filter(r => r);
			
			if( requiredBySelection.length > 0 ) {
				const apps = requiredBySelection.filter(_arrayUnique).join(', ');
				const app = _appName(element);
				flashMessage(`${app} est requis par : ${apps}`, 'error', null, 2000);
				return;
			}
			
			const checkbox = __checkbox(element);
			element.classList.remove(selectedClass);
			if( checkbox && checkbox.checked ) {
				checkbox.checked = false;
			}
		};
		
		
		elements.forEach(element => {

			const _init = () => {
				if( element.classList.contains('selected') ) {
					_select(element);
					return;
				}
				_deselect(element);
			};
		
			
			if(! element.classList.contains('disabled') && ! element.classList.contains('readonly') ) {
				element.addEventListener('click', () => {
					//alert('click');
					if(! element.classList.contains('selected') ) {
						_select(element);
						return;
					}
					_deselect(element);
				});
			}
			
			_init();
		});
	};
	
	document.addEventListener('pageLoad', () => {
		const selectboxesArr = Array.from(document.querySelectorAll(`.selectboxes:not(.${initializedClass})`));
		selectboxesArr.forEach(selectboxes => Selectboxes(selectboxes));
	});
})();